// Minimal bootstrap - decides which mode to load
// This file should be as small as possible (target: <5KB)

// Set webpack public path if provided by embed script
// Note: __webpack_public_path__ is a special webpack variable that will be replaced at build time
/* global __webpack_public_path__ */
if (typeof window !== 'undefined' && window.__webpack_public_path__) {
  // This will be handled by webpack at runtime
  // eslint-disable-next-line no-global-assign
  __webpack_public_path__ = window.__webpack_public_path__;
}

// Environment variables to control build mode
const BUILD_MODE = process.env.REACT_APP_BUILD_MODE; // 'embedded', 'standalone', or undefined (both modes)

// Static imports for embedded mode - merged into single bundle
// Dynamic imports for standalone mode - separate chunk
let loadStandalone = null;
let loadEmbedded = null;

// This conditional will be evaluated at build time and dead code eliminated
if (BUILD_MODE === 'embedded') {
  // Static import for embedded mode - merges into main bundle
  loadEmbedded = () => {
    require('./embedded-entry');
  };
} else {
  // Dynamic import for standalone mode - separate chunk
  loadStandalone = () => {
    return import(
      /* webpackChunkName: "standalone" */
      /* webpackMode: "lazy" */
      './standalone-entry'
    );
  };
}

// Detect environment and load appropriate entry
function bootstrap() {
  // Check if we're in embedded mode
  const hasEmbeddedContainers =
    document.querySelector('#sb3-container') ||
    document.querySelector('.compatio-builder-container') ||
    document.querySelector('#compatio-sb3-button') ||
    document.querySelector('[compatio-builder]');

  // Check if we're in standalone mode
  const hasRootContainer = document.getElementById('root');

  // Simple condition: if BUILD_MODE is "embedded", only load embedded mode, otherwise load standalone mode
  if (BUILD_MODE === 'embedded') {
    // Embedded-only build - static import (merged into main bundle)
    if (hasEmbeddedContainers) {
      if (loadEmbedded) {
        loadEmbedded();
      }
    }
  } else {
    // Standalone-only build (default)
    if (hasRootContainer) {
      if (loadStandalone) {
        loadStandalone().catch(error => {
          console.error('Failed to load standalone mode:', error);
        });
      }
    }
  }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  // DOM is already ready
  bootstrap();
}